<template>
  <el-dialog title="身份证号管理"
             :visible.sync="showModal"
             @close="handleCancel"
             append-to-body
             width="80%">
    <el-row>
      <el-row class="mb-15">
        <el-button v-has="'/med_id/add'"
                   type="primary"
                   @click="handleInput()">录入身份证号码</el-button>
      </el-row>
      <el-card shadow="none">
        <el-table max-height="575"
                  ref="multipleTable"
                  :data="tableData">
          <el-table-column label="序号"
                           type="index"
                           width="60"></el-table-column>
          <el-table-column label="身份证号码"
                           prop="svalue"
                           min-width="180"
                           :show-overflow-tooltip="true">
          </el-table-column>

          <el-table-column label="姓名"
                           prop="name"
                           min-width="80"
                           :show-overflow-tooltip="true">
          </el-table-column>

          <el-table-column label="性别"
                           prop="sex"
                           min-width="60"
                           :show-overflow-tooltip="true">
          </el-table-column>

          <el-table-column label="民族"
                           prop="nation"
                           min-width="100"
                           :show-overflow-tooltip="true">
          </el-table-column>

          <el-table-column label="出生日期"
                           prop="birthday"
                           min-width="100"
                           :show-overflow-tooltip="true">
          </el-table-column>

          <el-table-column label="住址"
                           prop="address"
                           min-width="320"
                           :show-overflow-tooltip="true">
          </el-table-column>

          <el-table-column label="有效期起"
                           prop="start_date"
                           min-width="100"
                           :show-overflow-tooltip="true">
          </el-table-column>

          <el-table-column label="有效期止"
                           prop="end_date"
                           min-width="100"
                           :show-overflow-tooltip="true">
          </el-table-column>

          <el-table-column prop="base64"
                           label="证件照片"
                           header-align="center"
                           align="center">
            <template slot-scope="scope">
              <el-popover placement="top-start"
                          title
                          trigger="hover">
                <img :src="`data:image/bmp;base64,` + scope.row.base64"
                     alt
                     style="width: 260px;height: 320px;" />
                <img slot="reference"
                     :src="`data:image/bmp;base64,` + scope.row.base64"
                     style="width: 26px;height: 32px" />
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column fixed="right"
                           label="操作"
                           width="80">
            <template slot-scope="scope">
              <el-button v-has="'/med_id/del'"
                         size="mini"
                         type="danger"
                         @click="handleDelete(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-card>
      <el-dialog title="身份证号录入"
                 :visible.sync="showInput"
                 @close="cancelInput"
                 append-to-body
                 width="40%">
        <el-col :span="24">
          <el-form :model="manInfo"
                   :rules="manRules"
                   ref="manForm"
                   label-width="80px"
                   class="man-form">
            <el-input v-model.trim="manInfo.svalue"
                      placeholder="请输入18位身份证号码"></el-input>
          </el-form>
        </el-col>
        <span slot="footer"
              class="dialog-footer">
          <el-button @click="cancelInput">取 消</el-button>
          <el-button v-has="'/med_id/add'"
                     type="primary"
                     :disabled="manInfo.svalue.length != 18"
                     @click="confirmInput('manForm')">
            确 定
          </el-button>
        </span>
      </el-dialog>
    </el-row>
    <span slot="footer"
          class="dialog-footer">
      <el-button type="primary"
                 @click="handleCancel">关 闭</el-button>
    </span>
  </el-dialog>
</template>

<script>
import fetch from '@/common/api'
//import utils from '@/common/utils'
export default {
  props: {
    isShow: {
      type: Boolean
    },
    data: {
      type: Object
    }
  },
  data() {
    // var validatePass = (rule, value, callback) => {
    //   if ((value + '').length < 8) {
    //     callback(new Error('请输入8位数字密码'))
    //   }
    //   callback()
    // }
    return {
      showModal: this.isShow,
      manInfo: {
        svalue: ''
      },
      manRules: {
        svalue: [
          //{ required: true, message: '请选择密码' }
          // { validator: validatePass, trigger: 'blur' },
          // { type: 'number', message: '密码必须为数字值' }
        ]
      },
      showInput: false,
      tableData: [],
      passList: [],
      randomNum: ''
    }
  },
  created() {
    this.getInfo()
  },
  methods: {
    // 获取编辑信息
    getInfo() {
      fetch.getIdList({ person_id: this.data.id }).then((data) => {
        data.procData(
          data.res,
          (data) => {
            this.tableData = data.list.map((item) => {
              item.sex = item.sex === '1' ? '男' : item.sex === '2' ? '女' : '未知'
              item.birthday =
                item.birthday.substr(0, 4) +
                '-' +
                item.birthday.substr(4, 2) +
                '-' +
                item.birthday.substr(6, 2)
              item.start_date =
                item.start_date.substr(0, 4) +
                '-' +
                item.start_date.substr(4, 2) +
                '-' +
                item.start_date.substr(6, 2)
              item.end_date =
                item.end_date.substr(0, 4) +
                '-' +
                item.end_date.substr(4, 2) +
                '-' +
                item.end_date.substr(6, 2)
              return item
            })
          },
          (err) => {
            this.$message.error(err)
          }
        )
      })
    },
    handleDelete(data) {
      this.$confirm('是否确定删除选中的数据?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          fetch.delId({ id: data.id, person_id: this.data.id }).then((data) => {
            data.procData(
              data.res,
              () => {
                this.getInfo()
                this.$message.success('操作成功')
              },
              (err) => {
                this.$message.error(err)
              }
            )
          })
        })
        .catch(() => {})
    },
    confirmInput(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          fetch.addId({ ...this.manInfo, person_id: this.data.id }).then((data) => {
            data.procData(
              data.res,
              () => {
                this.getInfo()
                this.$message.success('操作成功')
                this.showInput = false
                this.$refs[formName].resetFields()
              },
              (err) => {
                this.$message.error(err)
              }
            )
          })
        } else {
          return false
        }
      })
    },
    handleInput() {
      this.showInput = true
    },
    cancelInput() {
      this.showInput = false
    },
    handleCancel() {
      this.$emit('handleClose')
    },
    getRandomNum() {
      let randomNum = new Date().getTime() + ''
      let tmpLen = randomNum.length
      let $chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678'
      let maxPos = $chars.length
      for (var i = 0; i < 32 - tmpLen; i++) {
        randomNum += $chars.charAt(Math.floor(Math.random() * maxPos))
      }
      return randomNum
    }
  }
}
</script>

<style></style>
